import { useMemo, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { UrlParam } from "../constants/urlParams";

// Get query params
export const useQueryParams = (): URLSearchParams => {
    return new URLSearchParams(useLocation().search);
}

// Get query param (memoized)
export const useQueryParam = (paramName: UrlParam): string | null => {
    const search = useLocation().search;

    return useMemo(() => {
        const params = new URLSearchParams(search);
        return params.get(paramName);
    }, [paramName, search]);
}

export const usePreventPageClose = (showAlert: boolean): void => {
    useEffect(() => {
        if (showAlert) {
            window.onbeforeunload = () => true;
        } else {
            window.onbeforeunload = () => undefined;
        }

        return () => window.onbeforeunload = null;
    }, [showAlert]);
}

// Get a link to current url with new fragment
export const useUrlFragment = (fragmentName: string): string => {
    const location = useLocation();

    return useMemo(() => {
        return `${window.location.origin}${location.pathname}${location.search}#${fragmentName}`;
    }, [location, fragmentName]);
}
